/**
 * @enum {string}
 */
export const enum AssetType {
  VOD = 'VOD',
  PROGRAM = 'PROGRAM',
  SERIES = 'SERIES',
  CHANNEL = 'CHANNEL',
  SCHEDULE = 'SCHEDULE',
  RECORDING = 'RECORDING',
  ARTICLE = 'ARTICLE',
  BUNDLE = 'BUNDLE',
  PRODUCT = 'PRODUCT',
  SUBSCRIPTION = 'SUBSCRIPTION',
  PAGE = 'PAGE',
}

/**
 * @enum {string}
 */
export const enum ActionMethod {
  DETAIL = 'DETAIL',
  PLAY = 'PLAY',
  PLAY_TRAILER = 'PLAY_TRAILER',
  // custom methods
  JUMP_TO_LIST = 'jump_to_list',
  FAVOURITE = 'favourite',
  OPEN_FOLDER = 'open_folder',
}

/**
 * @enum {string}
 */
export const enum FocusType {
  ANY = 'ANY',
  FUTURE = 'FUTURE',
  PAST = 'PAST',
}

/**
 * @enum {string}
 */
export const enum ExtraDataType {
  NONE = 'NONE',
  MINI = 'MINI',
}

export const enum AdultType {
  True = 'true',
  False = 'false',
  Any = 'any',
}

/**
 * @enum {string}
 */
export const enum CardType {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT',
}

/**
 * @enum {string}
 */
export const enum SortBy {
  title = 'TITLE',
  created = 'CREATED',
  episode = 'EPISODE',
  schedule = 'SCHEDULE',
}

/**
 * @enum {string}
 */
export const enum SortDir {
  Asc = 'ASC',
  Desc = 'DESC',
}

/**
 * @enum {string}
 */
export const enum CardSize {
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Normal = 'NORMAL',
  Large = 'LARGE',
  ExtraLarge = 'EXTRA_LARGE',
  MiniEpg = 'MINI_EPG',
}

/**
 * @enum {string}
 */
export const enum StreamType {
  LINEAR = 'LINEAR',
  REPLAY = 'REPLAY',
  VOD = 'VOD',
  SVOD = 'SVOD',
  FVOD = 'FVOD',
  TVOD = 'TVOD',
  NPVR = 'NPVR',
  DVBC = 'DVBC',
  RECORDING = 'RECORDING',
}

/**
 * @enum {string}
 */
export const enum CustomerFeature {
  NO_ADULT = 'NO_ADULT',
  NO_RENT = 'NO_RENT',
  NO_UPSELL = 'NO_UPSELL',
}

/**
 * @enum {string}
 */
export const enum PageType {
  Cms = 'CMS_PAGE',
  Search = 'SEARCH_PAGE',
  Guide = 'TV_GUIDE_PAGE',
  List = 'LIST_PAGE',
  Settings = 'SETTINGS_PAGE',
  Reminders = 'REMINDERS_PAGE',
  RecordingRecorded = 'RECORDINGS_RECORDED_PAGE',
  RecordingPlanned = 'RECORDINGS_PLANNED_PAGE',
  RecordingConflict = 'RECORDINGS_CONFLICT_PAGE',
  RecordingExpired = 'RECORDINGS_EXPIRE_PAGE',
  SubscriptionAvailable = 'SUBSCRIPTIONS_AVAILABLE_PAGE',
  SubscriptionActive = 'SUBSCRIPTIONS_ACTIVE_PAGE',
  MessageInbox = 'MESSAGES_INBOX_PAGE',
  Apps = 'APPS_PAGE',
  ClientArea = 'CLIENT_AREA_PAGE',
}

/**
 * @enum {string}
 */
export const enum CmsProperty {
  AllowAdult = 'ALLOW_ADULT',
  VodFilterCategory = 'VOD_FILTER_CATEGORY',
  VodFilterProductionYear = 'VOD_FILTER_PRODUCTIONYEAR',
  VodFilterRating = 'VOD_FILTER_RATING',
  AuthRequired = 'AUTH_REQUIRED',
  NpvrRequired = 'NPVR_REQUIRED',
  LocalRecorderRequired = 'LOCAL_RECORDER_REQUIRED',
  AdultRequired = 'ADULT_REQUIRED',
  FocusPast = 'FOCUS_PAST',
  FocusFuture = 'FOCUS_FUTURE',
  Unknown = 'UNKNOWN',
  ShowProgress = 'SHOWPROGRESS',
  UseBestSchedule = 'USE_BEST_SCHEDULE',
  ShowScheduleInfo = 'SHOW_SCHEDULE_INFO',
  ShowEpisodeInfo = 'SHOW_EPISODE_INFO',
  HideInfo = 'HIDE_INFO',
  HideMiniDetail = 'HIDE_MINI_DETAIL',
  LiveThumbnail = 'LIVE_THUMBNAIL',
}

/**
 * @enum {string}
 */
export const enum BannerSize {
  ASPECT_RATIO_7_1 = 'ASPECT_RATIO_7_1',
  ASPECT_RATIO_7_2 = 'ASPECT_RATIO_7_2',
  ASPECT_RATIO_7_3 = 'ASPECT_RATIO_7_3',
}

export interface QueryParam {
  [key: string]: string | boolean | number | Array<string | boolean | number> | undefined;
}

/**
 * @param {string[]} cmsProperties
 * @return {FocusType}
 */
export function focusTypeFromProperties(cmsProperties: string[]): FocusType {
  if (cmsProperties.some(it => it === CmsProperty.FocusFuture)) {
    return FocusType.FUTURE;
  }
  if (cmsProperties.some(it => it === CmsProperty.FocusPast)) {
    return FocusType.PAST;
  }
  return FocusType.ANY;
}
